import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (31 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisOperasyon = {

  AddCustomerAdditionalNote(token, userID, note) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-customer-additional-note`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        note
      }
    });
  },

  CreateAdditionalService(token, title, price, currency) {
    return axios({
      method: "post",
      url: `${API_URL}flow/additional-services-create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        price,
        currency
      }
    });
  },

  UpdateAdditionalService(token, serviceID, title, price, currency) {
    return axios({
      method: "post",
      url: `${API_URL}flow/additional-services-update`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        serviceID,
        title,
        price,
        currency
      }
    });
  },

  RemoveAdditionalService(token, serviceID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/additional-services-remove`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        serviceID
      }
    });
  },

  GetAdditionalService(token, serviceID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-additional-service`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        serviceID
      }
    });
  },

  GetAdditionalServices(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-additional-services`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  CancelOperation(token, operationID, cancelReason) {
    return axios({
      method: "post",
      url: `${API_URL}flow/cancel-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        operationID,
        cancelReason
      }
    });
  },

  // Depo odasına (snapshot) yetkili kişi ekleme/listeleme/kaldırma (BE: snapshot-authorized-users).
  // Yetki BE'de zorlanır: oda sahibi müşteri + admin ekler/kaldırır; merchant yalnız listeler.
  // email veya phone'dan en az biri zorunlu. Yeni kişi users'a type=customer açılır (welcome
  // maili GİTMEZ). Dönüş (add): {authorizationID, userID, userCreated, roomNo}.
  // permissions: { paymentsView, paymentsEdit, billingInfoView, billingInfoEdit, roomVisit,
  // contractsView, contractsEdit, roomItemsEdit, notificationsEnabled } — 1/0. GÖNDERİLMEYEN
  // anahtar BE'de NULL (hiç verilmemiş yetki) olarak kalır; 0 "açıkça kapatılmış" demektir.
  AddSnapshotAuthorizedUser(token, { snapshotID, name, lastname, email, phone, relation, note, permissions }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-snapshot-authorized-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        snapshotID,
        name: name || "",
        lastname: lastname || "",
        email: email || "",
        phone: phone || "",
        relation: relation || "",
        note: note || "",
        ...(permissions && typeof permissions === "object" ? permissions : {}),
      }
    });
  },

  // Mevcut yetkilinin izinlerini günceller. permissions'ta OLMAYAN anahtar NULL'a çekilir.
  UpdateSnapshotAuthorizedUserPermissions(token, { authorizationID, permissions, relation, note }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-snapshot-authorized-user-permissions`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        authorizationID,
        ...(relation !== undefined ? { relation } : {}),
        ...(note !== undefined ? { note } : {}),
        ...(permissions && typeof permissions === "object" ? permissions : {}),
      }
    });
  },

  // Dönüş (result): {snapshotID, roomNo, authorizedUsers:[{authorization_id,user_id,relation,note,
  // created_date_time, <yetki sütunları>, permissions:{...efektif}, name,lastname,email,phone}]}.
  GetSnapshotAuthorizedUsers(token, snapshotID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-snapshot-authorized-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { snapshotID }
    });
  },
  RemoveSnapshotAuthorizedUser(token, authorizationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-snapshot-authorized-user`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: { authorizationID }
    });
  },

  CreateOperation(
    token,
    type,
    status,
    customerID,
    corporationID,
    warehouseID,
    appointmentDate,
    appointmentTime,
    address,
    authorizedNameLastname,
    authorizedPhone,
    additionalNote,
    feasibilityOperationSubject,
    operationDate
  ) {
    const data = {
      type, // "feasibility" veya "warehouse-visit"
      customerID, // Seçilen müşterinin ID'si
      corporationID, // Fizibilite Talebinde "Firma" dropdownunda seçtiğim firma ID'si, Depo Ziyaretinde "Satıcı" dropdownında seçtiğimin ID'si
      appointmentTime,
      status,
      address,
      authorizedNameLastname,
      authorizedPhone, // Country Code + Phone şeklinde birleştirilip gönderilecek
      additionalNote // Fizibilite Talebi ise Not kısmı ve fizibilite raporu kısmı birleştirilip yollanacak, Depo Ziyareti ise sadece Not gönderilecek
    };

    if (String(type) === "operation") {
      data.operationDate = operationDate || appointmentDate; // "2026-01-17" formatında olacak
    } else {
      data.appointmentDate = appointmentDate; // "2026-01-17" formatında olacak
    }

    const hasWarehouseId = warehouseID !== undefined && warehouseID !== null && String(warehouseID).trim() !== "";
    if (String(type) !== "feasibility" && hasWarehouseId) data.warehouseID = warehouseID; // Fizibilite Talebi ise hiç gönderilmeyecek
    if (String(type) === "feasibility" && String(feasibilityOperationSubject || "").trim()) {
      data.feasibilityOperationSubject = String(feasibilityOperationSubject).trim();
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/create-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  // "Depo Çıkışı" operasyonu (yeni type: "warehouse-exit").
  // Depo Bilgilerim sayfasında müşteri nakliye istemediğinde oluşturulur:
  // tarih (operationDate) + saat (appointmentTime) + not. roomNo ile kaynak odaya bağlanır.
  CreateWarehouseExitOperation(
    token,
    {
      customerID,
      corporationID,
      warehouseID,
      roomNo,
      sourceStorageOperationID,
      sourceSnapshotID,
      operationDate,
      appointmentTime,
      additionalNote,
      status,
    } = {}
  ) {
    const data = {
      type: "warehouse-exit",
      customerID,
      corporationID,
      operationDate,
      appointmentDate: operationDate, // operationDate ile aynı değer
      appointmentTime,
      additionalNote,
      status,
    };

    if (warehouseID !== undefined && warehouseID !== null && String(warehouseID).trim() !== "") {
      data.warehouseID = warehouseID;
    }
    if (roomNo !== undefined && roomNo !== null && String(roomNo).trim() !== "") {
      data.roomNo = roomNo;
    }
    if (
      sourceStorageOperationID !== undefined &&
      sourceStorageOperationID !== null &&
      String(sourceStorageOperationID).trim() !== ""
    ) {
      data.sourceStorageOperationID = sourceStorageOperationID;
    }
    // Kesin bağ: çıkışın hangi giriş snapshot(lar)ına ait olduğu (grup çıkışında
    // birden fazla id virgülle). Oda no'ları yeniden kullanıldığı için
    // operationID+roomNo eşleştirmesi tek başına yeterli değil.
    if (
      sourceSnapshotID !== undefined &&
      sourceSnapshotID !== null &&
      String(sourceSnapshotID).trim() !== ""
    ) {
      data.sourceSnapshotID = sourceSnapshotID;
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/create-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  // filters: { operationID, customerID, corporationID, warehouseID, status, type }
  // Backend bu filtreleri destekliyor (operations::get); tekil operasyon çekmek için
  // tüm listeyi indirmek gerekmez.
  GetOperations(token, filters = {}) {
    const data = {};
    ["operationID", "customerID", "corporationID", "warehouseID", "status", "type"].forEach((key) => {
      const value = filters?.[key];
      if (value !== undefined && value !== null && String(value).trim() !== "") data[key] = value;
    });
    return axios({
      method: "post",
      url: `${API_URL}flow/get-operations`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  // --- Operation Snapshots ---
  // Bir operasyonun belirli andaki durumunun (oda, tarih, hacim, fiyat, statü)
  // kaydı. createOperation'da otomatik oluşur. status = -1 olanlar (eskimiş) dönmez.
  // Filtresiz/sadece customerID ile çağrılınca müşterinin tüm aktif snapshot'ları gelir.
  GetOperationSnapshots(token, { operationID, customerID, warehouseID } = {}) {
    const data = {};
    if (operationID !== undefined && operationID !== null && String(operationID).trim() !== "") data.operationID = operationID;
    if (customerID !== undefined && customerID !== null && String(customerID).trim() !== "") data.customerID = customerID;
    if (warehouseID !== undefined && warehouseID !== null && String(warehouseID).trim() !== "") data.warehouseID = warehouseID;
    return axios({
      method: "post",
      url: `${API_URL}flow/get-operation-snapshots`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data,
    });
  },
  // Mevcut bir operasyon için manuel snapshot oluşturur (örn. "Oda Ekle": aynı operationID'ye
  // yeni bir oda/snapshot eklemek). operationID zorunlu, kalan tüm alanlar opsiyoneldir.
  CreateOperationSnapshot(token, payload = {}) {
    const source = payload && typeof payload === "object" ? payload : {};
    const operationID = String(source.operationID ?? source.operationId ?? source.operation_id ?? "").trim();
    const data = {
      ...source,
      ...(operationID ? { operationID } : {}),
    };
    return axios({
      method: "post",
      url: `${API_URL}flow/create-operation-snapshot`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data,
    });
  },
  // Aktif snapshot'ı status=-1 yapıp gönderilen alanlarla yeni snapshot oluşturur.
  // referenceID backend tarafından otomatik set edilir. operationID zorunlu, kalanı opsiyonel.
  UpdateOperationSnapshot(token, payload = {}) {
    const source = payload && typeof payload === "object" ? payload : {};
    const snapshotID = String(source.snapshotID ?? source.snapshotId ?? source.snapshot_id ?? "").trim();
    const data = {
      ...source,
      ...(snapshotID ? { snapshotID } : {}),
    };
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation-snapshot`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data,
    });
  },

  // --- Tekil (id-filtreli) çekimler: canlı senkronda yerinde upsert için ---
  // Parametre verilince backend tek kayıt döner (liste kaydıyla aynı şekil),
  // bulunamazsa boş döner (silinmiş = listeden çıkar).
  GetOperationById(token, operationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-operations`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { operationID },
    });
  },

  UpdateOperation(
    token,
    operationID,
    {
      type,
      status,
      customerID,
      corporationID,
      warehouseID,
      appointmentDate,
      operationDate,
      appointmentTime,
      address,
      fromAddress,
      toAddress,
      authorizedNameLastname,
      authorizedPhone,
      secondAuthorizedNameLastname,
      secondAuthorizedPhone,
      additionalNote,
      investigationReport,
      feasibilityOperationSubject
    }
  ) {
    const data = { operationID };

    if (type !== undefined && type !== null && String(type).trim() !== "") data.type = type;
    if (status !== undefined && status !== null) data.status = status;
    if (customerID !== undefined && customerID !== null) data.customerID = customerID;
    if (corporationID !== undefined && corporationID !== null) data.corporationID = corporationID;
    if (appointmentDate !== undefined && appointmentDate !== null) data.appointmentDate = appointmentDate;
    if (operationDate !== undefined && operationDate !== null) data.operationDate = operationDate;
    if (appointmentTime !== undefined && appointmentTime !== null) data.appointmentTime = appointmentTime;
    if (address !== undefined && address !== null) data.address = address;
    // Alınacak/bırakılacak adresler ve 2. yetkili: modal bunları düzenletiyordu ama istek
    // gövdesine hiç eklenmiyordu (backend tarafı da yeni eklendi).
    if (fromAddress !== undefined && fromAddress !== null) data.fromAddress = fromAddress;
    if (toAddress !== undefined && toAddress !== null) data.toAddress = toAddress;
    if (authorizedNameLastname !== undefined && authorizedNameLastname !== null) data.authorizedNameLastname = authorizedNameLastname;
    if (authorizedPhone !== undefined && authorizedPhone !== null) data.authorizedPhone = authorizedPhone;
    if (secondAuthorizedNameLastname !== undefined && secondAuthorizedNameLastname !== null) data.secondAuthorizedNameLastname = secondAuthorizedNameLastname;
    if (secondAuthorizedPhone !== undefined && secondAuthorizedPhone !== null) data.secondAuthorizedPhone = secondAuthorizedPhone;
    if (additionalNote !== undefined && additionalNote !== null) data.additionalNote = additionalNote;

    const hasWarehouseId = warehouseID !== undefined && warehouseID !== null && String(warehouseID).trim() !== "";
    if (hasWarehouseId) data.warehouseID = warehouseID;

    if (String(investigationReport || "").trim()) data.investigationReport = investigationReport;
    if (String(feasibilityOperationSubject || "").trim()) {
      // TODO: Backend bu alanı resmi olarak eklediğinde `feasibilityOperationSubject` adını güncelle.
      data.feasibilityOperationSubject = String(feasibilityOperationSubject).trim();
    }

    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  UpdateOperationReport(token, operationID, investigationReport) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        operationID,
        investigationReport
      }
    });
  },

  AssignOperationCompany(token, operationID, corporationID) {
    const data = {
      operationID,
      corporationID,
    };
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data
    });
  },

  CompleteOperation(token, operationID, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      // Varsayılan tamamlanma statüsü 1 (Tamamlandı); payload.status verilirse override edilir.
      // Depolamada tamamlama artık status 6 (Sözleşme Bekleniyor) gönderir — snapshot yine yazılır,
      // operasyon sözleşme imzasını bekler; tüm imzalar bitince backend 6→1 yapar.
      data: {
        status: 1,
        ...(payload && typeof payload === "object" ? payload : {}),
        operationID,
      }
    });
  },

  ApproveOperation(token, operationID, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        ...(payload && typeof payload === "object" ? payload : {}),
        operationID,
        status: 2,
      }
    });
  },

  MarkOperationWillHappen(token, operationID, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        ...(payload && typeof payload === "object" ? payload : {}),
        operationID,
        status: 8,
      }
    });
  },

  MarkOperationInProgress(token, operationID, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        ...(payload && typeof payload === "object" ? payload : {}),
        operationID,
        status: 9,
      }
    });
  },

  GetTeamsByOperationID(token, operationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-teams-by-operation-id`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        operationID,
      },
    });
  },

  AddTeamToOperation(token, { companyID, operationID, members }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-team-to-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        operationID,
        members,
      },
    });
  },

  UpdateTeamMembers(token, { operationID, members }) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-team-members`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        operationID,
        members,
      },
    });
  },

  PlanOperation(token, operationID, payload = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-operation`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        ...(payload && typeof payload === "object" ? payload : {}),
        operationID,
        status: 5,
      }
    });
  },

  OperationAddImages(token, operationID, images) {
    return axios({
      method: "post",
      url: `${API_URL}flow/operation-add-images`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        operationID,
        images
      }
    });
  },

  OperationRemoveImages(token, operationID, images) {
    return axios({
      method: "post",
      url: `${API_URL}flow/operation-remove-image`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        operationID,
        images
      }
    });
  },
};

export default servisOperasyon;
